var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71468 2.37811C7.80449 2.10172 8.19551 2.10172 8.28532 2.37812L9.50424 6.12959C9.54441 6.25319 9.65959 6.33688 9.78956 6.33688H13.7341C14.0247 6.33688 14.1455 6.70877 13.9104 6.87959L10.7192 9.19812C10.6141 9.27452 10.5701 9.40993 10.6103 9.53353L11.8292 13.285C11.919 13.5614 11.6026 13.7912 11.3675 13.6204L8.17634 11.3019C8.07119 11.2255 7.92881 11.2255 7.82366 11.3019L4.63247 13.6204C4.39736 13.7912 4.08101 13.5614 4.17082 13.285L5.38975 9.53353C5.42991 9.40993 5.38591 9.27452 5.28077 9.19812L2.08957 6.87959C1.85446 6.70877 1.97529 6.33688 2.26591 6.33688H6.21044C6.34041 6.33688 6.45559 6.25319 6.49576 6.12959L7.71468 2.37811Z",
    fill: "#FFC01D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.c406a807fd91f1bcdf6aa755c222fab0.svg";
export { ForwardRef as ReactComponent };